import z from "zod";

export const DELETE_ACCOUNT_CONFIRMATION = "DELETE MY ACCOUNT";

export const updateProfileSchema = z.object({
  firstName: z.string().min(1, "First name is required").max(32, "First name is too long, it must not exceed 32 characters"),

  lastName: z.string().min(1, "Last name is required").max(32, "Last name is too long, it must not exceed 32 characters"),
});

export const updateEmailAddressSchema = z.object({
  emailAddress: z.email({ message: "Email address is not a valid email" }).min(1, "Email address is required").max(256, "Email address is too long, it must not exceed 256 characters"),

  currentPassword: z.string().min(1, "Enter your current password to confirm this change"),
});

export const updatePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Current password is required"),

    newPassword: z
      .string()
      .min(8, "Password is too short, it must be at least 8 characters")
      .max(64, "Password is too long, it must not exceed 64 characters")
      .regex(/[A-Z]/, "Password must include an uppercase letter")
      .regex(/[a-z]/, "Password must include a lowercase letter")
      .regex(/[0-9]/, "Password must include a number")
      .regex(/[^A-Za-z0-9]/, "Password must include a special character"),

    confirmNewPassword: z.string().min(1, "Confirm password is required"),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Passwords do not match",
    path: ["confirmNewPassword"],
  })
  .refine((data) => data.newPassword !== data.currentPassword, {
    message: "New password must be different from your current password",
    path: ["newPassword"],
  });

export const deleteAccountSchema = z.object({
  // The explicit boolean return type stops TypeScript inferring a type predicate,
  // which would otherwise narrow the field to the literal confirmation string.
  confirmation: z.string().refine((value): boolean => value === DELETE_ACCOUNT_CONFIRMATION, `Type "${DELETE_ACCOUNT_CONFIRMATION}" exactly to confirm`),
});

export type UpdateProfileSchema = z.infer<typeof updateProfileSchema>;
export type UpdateEmailAddressSchema = z.infer<typeof updateEmailAddressSchema>;
export type UpdatePasswordSchema = z.infer<typeof updatePasswordSchema>;
export type DeleteAccountSchema = z.infer<typeof deleteAccountSchema>;
